import React, { useState } from "react"
import { roleCheck } from "utils/index"
import {
  OPERATION_MANAGER,
  SURVEYORS_USER,
  APPROVE_CADASTRAL,
} from "utils/constants"
import { useSelector } from "react-redux"
import CadastralRequestModal from "../../modals/CadastralRequestModal"
import { updateJobServiceTransition } from "../../../../../../requesters/jobServiceRequester"
import { getBaseUrl } from "../../../../reducers"

const CadastralRequestActivity = ({
  jobService,
  reloadData,
  systemRole,
  currentTeamRole,
}) => {
  const {
    id, attributes: {
      state,
      forProjectX,
    }
  } = jobService
  const bgCadestralPending = ((state === "cadastral_requested") && currentTeamRole.includes(SURVEYORS_USER)) ? "bg-coral" : null
  const [showCadastralActionModal, setShowCadastralActionModal] = useState(false)
  const [cadastralAction, setCadastralAction] = useState("decline")
  const [requesting, setRequesting] = useState(false)
  const baseUrl = useSelector(getBaseUrl)

  const onApprove = () => {
    setRequesting(true)
    updateJobServiceTransition(baseUrl, id, APPROVE_CADASTRAL)
    .then(res => {
      if (res.status === 200) {
        reloadData()
      }
    })
    // eslint-disable-next-line no-console
    .catch(err => console.log(err))
    .finally(() => setRequesting(false))
  }

  return (
    state === "cadastral_requested" && forProjectX && (
      <div className="timeline-item mt-2 mb-2">
        <div className={`card border-0 shadow-sm ${bgCadestralPending}`}>
          <div className="card-body">
            <div className="row px-3 flex-column">
              <p className="mb-0">
                Job Pending Cadastral Approval from Operations
              </p>
            </div>
          </div>
        </div>
        {(roleCheck(systemRole, currentTeamRole, OPERATION_MANAGER) && state === "cadastral_requested") && (
          <div className="row mt-3 ml-1">
            <div className="mr-2">
              <button
                className="btn btn-outlined-blue"
                onClick={() => {
                  setCadastralAction("approve")
                  setShowCadastralActionModal(true)
                }}
                disabled={requesting}
                type="button">
                Approve
              </button>
            </div>
            <div className="mr-2">
              <button
                className="btn btn-outlined-red"
                disabled={requesting}
                onClick={() => {
                  setCadastralAction("decline")
                  setShowCadastralActionModal(true)
                }}
                type="button">
                Decline
              </button>
              <CadastralRequestModal
                action={cadastralAction}
                jobService={jobService}
                reloadData={reloadData}
                show={showCadastralActionModal}
                onHide={() => setShowCadastralActionModal(false)} />
            </div>
          </div>
        )}
      </div>
    )
  )
}
export default CadastralRequestActivity
